<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Customer  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6" class="pr-5">
          <b-form-group label-cols=3 label="Customer Name">
              <b-form-input v-model="tblData.name"></b-form-input>
          </b-form-group>
          <b-form-group label-cols=3 label="Customer Code">
            <b-input-group>
              <b-form-input v-model="tblData.code" placeholder="Customer Code"></b-form-input>
              <b-input-group-append> <span class="pl-2 pt-2 pr-1"> Group </span></b-input-group-append>
                <b-form-select v-model="tblData.customer_group" :plain="true" :options="customerGroups" ></b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          
          <b-form-group label-cols=3 label="Contact Name">
            <b-input-group>
              <b-form-input v-model="tblData.contact" placeholder="contact name" style="width:60px;"></b-form-input>
              <b-input-group-append> <span class="pl-2 pt-2 pr-1"> NPWP </span></b-input-group-append>
              <b-form-input v-model="tblData.npwp" placeholder="NPWP No."></b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-group label-cols=3 label="Status">
            <b-input-group>
              <b-form-select v-model="tblData.isactive" :plain="true" :options="activeStatus" style="width:80px;"></b-form-select>
              <b-input-group-append> <span class="pl-2 pt-2 pr-1"> Sales(AE)</span></b-input-group-append>
              <b-form-input v-model="tblData.SalesCode" placeholder="Sales (AE)"></b-form-input>
            </b-input-group>
              <b-row>
                <b-col class="pl-1" offset="6" cols="6">
                  <b-row class="text-right">
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover 
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
      >
        <template v-slot:cell(Address)="data">
          {{ data.item.Address1 }}
          {{ data.item.Address2 }}
        </template>
        <template v-slot:cell(PhoneNo)="data">
          <span v-if="(data.item.PhoneNo)">P.{{data.item.PhoneNo}}</span>&nbsp;
          <span v-if="(data.item.FaxNo)">F.{{data.item.FaxNo}}</span>
        </template>
        <template v-slot:cell(CreditLimit)="data">
          {{data.item.CreditLimit | numFormat}}
        </template>
        <template v-slot:cell(isactive)="data">
          <span v-if="(data.item.isactive==0)" :class="data.item.isactive==0?'alert-success navbar-link p-1':'alert-danger navbar-link p-1'">Active</span>
          <span v-else :class="'alert-danger navbar-link p-1'">Inactive</span>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import customer from "../../apis/bakerycustomer";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showFilter:false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      terpilih:{customer_id:''},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        customer_group: ''
      },
      customerGroups:[{value:'', text:'--ALL--'},{value:'RETAIL', text:'RETAIL'}, {value:'WHOLESHALE', text:'WHOLESHALE'}],
      activeStatus : [{ value: '', text: '-- ALL --' }, { value: '1', text: 'Inactive' },{ value: '0', text: 'Active' }],
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "CustCode",
            thStyle: "width:50px",
            label: "Code",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "Address",
            label: "Billing Address",
          },
          {
            key: "City",
            label: "City",
            sortable: true
          },
          {
            key: "PhoneNo",
            label: "Phone/Fax",
            thStyle: "width:150px",
          },
          {
            key: "customer_group",
            label: "Customer Group",
            sortable: true
          },
          {
            key: "Bill2CustName",
            label: "Group/Holding",
            sortable: true
          },
          {
            key: "SalesCode",
            label: "Sales (AE)",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "npwp",
            label: "N P W P",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "isactive",
            label: "Status",
            sortable: true
          },
        ];
      return fields;
    },
  },
  created: async function() {
      const groups = await customer.group();
      this.customerGroups = groups.reduce((newArr, item) => {
                      newArr.push(item);
                  return newArr;
              }, [{value:'',text:'---ALL---'}]);
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await customer.mainlist(this.tblData);
      return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.name = '';
        this.tblData.code =  '';
        this.tblData.contact =  '';
        this.tblData.customer_group =  '';
        this.tblData.isactive = '';
        this.refresh();
    },
    add: function() {
          router.push({name :'bakery.customerfrm'});
    },
    edit: function() {
      if (this.terpilih.customer_id) {
        router.push({name :'bakery.customerfrm', params: { customer_id: this.terpilih.customer_id}});
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    deleteConfirm() {
      if (this.terpilih.customer_id) {
        this.showDelConfirm = true;
      } else {
            toastr.warn('Please select a row that want to be Deleted!');
      }
    },
    deleteData: async function() {
          try {
            await customer.remove(this.terpilih);
            this.refresh();
          } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
    },
    rowClicked(record, index) {
      if (this.terpilih.customer_id==record.customer_id) {
        console.log('terpilih row click: ', this.terpilih);
        this.edit();
      } else {
        if ((this.terpilih) && (this.terpilih._rowVariant)) {
            delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await customer.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    close(){
      router.push("home");
    },    

  }
};
</script>
